// @flow

import _ from 'lodash';

import Constants from 'constants/Constants';

let isInit = false;

let _mobileAutoEnable = true;

/**
 * On mobile we have to trick in order to allow us to play songs without direct user interaction.
 * _mobileEnabled allow us to know if the trick have been successfull.
 */
let _mobileEnabled = false;

let _ctx = null;

export default class NotificationUtils {

  /**
   * See http://ionden.com/a/plugins/ion.sound/en.html
   */
  static initSounds() {
    if (isInit === true) {
      return;
    }

    console.info('init sounds');

    ion.sound({
      sounds: [
        {
          name: Constants.Notification.AudioFile.ORDER_NEW,
          volume: 1,
          preload: false
        }
      ],
      volume: 1,
      path: '/sounds/',
      preload: true,
      multiplay: false,
      loop: 100
    });
    isInit = true;
  }

  /**
   * Work in progress.
   *
   *
   * Inspired by howler library.
   * By default, audio on iOS, Android, etc is locked until a sound is played within a user interaction, and then it plays normally the rest of the page session (Apple documentation: ). The default behavior of howler.js is to attempt to silently unlock audio playback by playing an empty buffer on the first touchend event.
   * See https://github.com/goldfire/howler.js/blob/cdcb68faff2f4187239ebc203efa7cb6c94087f5/dist/howler.js#L261
   *
   * https://developer.apple.com/library/safari/documentation/audiovideo/conceptual/using_html5_audio_video/PlayingandSynthesizingSounds/PlayingandSynthesizingSounds.html
   *
   * https://developer.apple.com/library/content/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
   *
   */
  static autoEnableOnMobile() {
    console.log('AudioMobile');

    if (!_mobileAutoEnable) {
      console.log('AudioMobile, not auto enable');
      return ;
    }

    /**
     * Call this method on touch start to create and play a buffer,
     * then check if the audio actually played to determine if
     * audio has now been unlocked on iOS, Android, etc.
     */
    const unlock = () => {
      if (!_mobileAutoEnable) {
        console.log('AudioMobile, not auto enable');
        return ;
      }

      console.log('AudioMobile touch end');

      // see http://stackoverflow.com/questions/24119684/web-audio-api-memory-leaks-on-mobile-platforms

      // If we don't have an AudioContext created yet, run the setup.
      if (!_ctx) {
        NotificationUtils.setupAudioContext();
      }

      // Create an empty buffer.
      const source = _ctx.createBufferSource();
      source.buffer = _ctx.createBuffer(1, 1, 22050);
      source.connect(_ctx.destination);

      // Play the empty buffer.
      if (typeof source.start === 'undefined') {
        console.log('AudioMobile  source start undefined');
        source.noteOn(0);
      } else {
        source.start(0);
      }

      // Setup a timeout to check that we are unlocked on the next event loop.
      source.onended = function() {
        console.log('AudioMobile onended');

        source.disconnect(0);

        // Prevent this check from happening again.
        _mobileAutoEnable = false;

        // Set to true to notify that our trick worked.
        _mobileEnabled = true;

        console.log('AudioMobile enabled');

        // Remove the touch start listener.
        document.removeEventListener('touchend', unlock, true);
      };
    };

    // Setup a touch start listener to attempt an unlock in.
    document.addEventListener('touchend', unlock, true);
  }

  static setupAudioContext() {
    let usingWebAudio = true;

    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        console.log('AudioMobile AudioContext');
        _ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        console.log('AudioMobile webkitAudioContext');
        _ctx = new webkitAudioContext();
      } else {
        usingWebAudio = false;
      }
    } catch(e) {
      usingWebAudio = false;
    }

    // No audio is available on this system
    if (!usingWebAudio) {
      console.warn('AudioMobile No audio available on this system');
    }
  }

  static getFileForNotification(notification: number) {
    switch (notification) {
      case Constants.Notification.ORDER_NEW:
        return Constants.Notification.AudioFile.ORDER_NEW;
      default:
        return Constants.Notification.AudioFile.ORDER_NEW;
    }
  }

  static hasIon(): boolean {
    return !_.isNil(ion) && !_.isNil(ion.sound)
  }

  static notify(notification: number) {
    NotificationUtils.initSounds();

    if (NotificationUtils.hasIon()) {
      ion.sound.play(NotificationUtils.getFileForNotification(notification));
    } else {
      console.warn(`no ion found, can't play notification`)
    }
  }

  static stopNotification(notification: number) {
    if (NotificationUtils.hasIon()) {
      ion.sound.stop(NotificationUtils.getFileForNotification(notification));
    } else {
      console.warn(`no ion found, can't play notification`)
    }
  }

  static notifyNewOrder() {
    NotificationUtils.notify(Constants.Notification.ORDER_NEW);
  }

  static stopNotifyNewOrder() {
    NotificationUtils.stopNotification(Constants.Notification.ORDER_NEW);
  }

}



// WEBPACK FOOTER //
// ./scripts/utils/NotificationUtils.js